import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { PreviewDataWrapperComponent } from '../../preview-data-wrapper/preview-data-wrapper.component';
import { Organizacja } from '../../../models/organizacja';
import { ConstLabelReaderPipe } from '../../../pipes/const-label-reader.pipe';
import { RODZAJ_PODMIOTU_LABELS } from '../../../enums/rodzaj-podmiotu.enum';

@Component({
  selector: 'app-preview-organization-details',
  imports: [PreviewDataWrapperComponent, ConstLabelReaderPipe],
  templateUrl: './preview-organization-details.component.html',
  styleUrl: './preview-organization-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreviewOrganizationDetailsComponent {
  public readonly organization = input<Organizacja>();
  protected readonly RODZAJ_PODMIOTU_LABELS = RODZAJ_PODMIOTU_LABELS;
}
